import clsx from 'clsx';
import React from 'react';
import styles from './Container.module.scss';

interface Props {
    size?: 's' | 'm' | 'l' | 'xl';
    center?: boolean;
    gap?: '0' | '16';
    marginTop?: '0' | '16';
    children: React.ReactNode;
}

export const Container = ({
    size = 'xl',
    center = false,
    gap = '0',
    marginTop = '0',
    children,
}: Props) => {
    const wrapClasses = clsx(
        styles.wrap,
        styles[size],
        styles[`gap-${gap}`],
        styles[`marginTop-${marginTop}`],
        {
            [styles.center]: center,
        }
    );
    return <div className={wrapClasses}>{children}</div>;
};
